import { PatchJSON } from "@/lib/http";
import { Loading } from "notiflix";
import { useForm } from "react-hook-form";
import { toast } from "sonner";

const ChangePassword = () => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: {
      old_password: "",
      password: "",
      password_confirmation: ""
    }
  });


  const onSubmit = async formData => {
    Loading.circle("Updating Password");
    const { err } = await PatchJSON({
      url: "/api/user",
      body: formData
    })
    if (!err) {
      toast.success("Password updated successfully")
      reset()
    } else {
      toast.error(err)
    }
    Loading.remove()
  };

  return (
    <section className="rounded-xl border p-5 shadow-2xl dark:border-darkBorder lg:p-7">
      <form className="space-y-3" onSubmit={handleSubmit(onSubmit)}>
        <div className="space-y-1">
          <label htmlFor="old-password" className="text-sm font-semibold">
            Old Password
          </label>
          <input
            type="password"
            id="old-password"
            {...register("old_password", {
              required: "Old password is required"
            })}
            className="w-full rounded-md border bg-gray-100 p-2 py-3 text-sm dark:border-darkBorder dark:bg-darkInput"
            placeholder="Enter old password"
          />
          {errors.old_password &&
            <p className="text-xs font-medium text-red-500">
              {errors.old_password.message}
            </p>}
        </div>

        <div className="space-y-1">
          <label htmlFor="new-password" className="text-sm font-semibold">
            New Password
          </label>
          <input
            type="password"
            id="new-password"
            {...register("password", {
              required: "New password is required",
              minLength: {
                value: 8,
                message: "Password must be at least 8 characters long"
              }
            })}
            className="w-full rounded-md border bg-gray-100 p-2 py-3 text-sm dark:border-darkBorder dark:bg-darkInput"
            placeholder="Enter new password"
          />
          {errors.password &&
            <p className="text-xs font-medium text-red-500">
              {errors.password.message}
            </p>}
        </div>

        <div className="space-y-1">
          <label htmlFor="confirm-password" className="text-sm font-semibold">
            Confirm Password
          </label>
          <input
            type="password"
            id="confirm-password"
            {...register("password_confirmation", {
              required: "Please confirm your password",
              validate: value =>
                value === watch("password") || "Passwords do not match"
            })}
            className="w-full rounded-md border bg-gray-100 p-2 py-3 text-sm dark:border-darkBorder dark:bg-darkInput"
            placeholder="Enter confirmed new password"
          />
          {errors.password_confirmation &&
            <p className="text-xs font-medium text-red-500">
              {errors.password_confirmation.message}
            </p>}
        </div>

        <div className="flex justify-end pt-3">
          <button
            className="rounded-md px-4 py-2 font-semibold text-white btn"
            type="submit"
          >
            Save Changes
          </button>
        </div>
      </form>
    </section>
  );
};

export default ChangePassword;
